import { useEffect, useState } from "react";
import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { SiteTransport } from "src/app/transports/site";
import { UserRole } from "src/app/transports/user";
import { useAuth } from "src/app/utils/useAuth";

const useSiteListByManagerOptions = (userId?: number) => {
    const [siteListByManagerOptions, setSiteListByManagerOptions] = useState<
        Array<SimpleFormSelectOption>
    >([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const { currentUser } = useAuth();
    useEffect(() => {
        setLoading(true);
        SiteTransport.optionsByProjectManager(userId || currentUser.id)
            .then((res) => {
                setSiteListByManagerOptions(res);
                setLoading(false);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    }, []);

    return {
        siteListByManagerOptions,
        loading,
        error,
        isLead: [UserRole.ROLE_ADMIN, UserRole.ROLE_LEAD_PROJECT_MANAGER].includes(
            currentUser.role
        ),
    };
};
export default useSiteListByManagerOptions;
